let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cGSfe"), load("8E4u5"), load("2F69B"), load("kOWvR"), load("4D7T2")]).then(() => parcelRequire('1x5LM'));